export const approvalConfigRouter = {
  list: {
    name: 'list-approval-config',
  },
  info: {
    name: 'info-approval-config',
  },
}

export default [
  {
    path: '/approval-configs',
    component: () =>
      import(
        /* webpackChunkName: "approval-configs" */ '@/view/pages/approval-configs/ApprovalConfig.vue'
      ),
    children: [
      {
        path: '/',
        name: approvalConfigRouter.list.name,
        component: () =>
          import(
            /* webpackChunkName: "approval-configs-list" */ '@/view/pages/approval-configs/list/List.vue'
          ),
        meta: {
          title: 'Danh sách cấu hình duyệt chi - ClickBuy',
        },
      },
      {
        path: 'info',
        name: approvalConfigRouter.info.name,
        component: () =>
          import(
            /* webpackChunkName: "approval-configs-info" */ '@/view/pages/approval-configs/info/Info.vue'
          ),
        children: [
          {
            path: '',
            component: () =>
              import(
                /* webpackChunkName: "approval-configs-info" */ '@/view/pages/approval-configs/info/Info.vue'
              ),
            meta: {
              title: 'Thông tin cấu hình duyệt chi - ClickBuy',
            },
          },
        ],
      },
    ],
  },
]
